<template>
    <transition name="fade">
        <div v-if="show" class="container">
            <div class="icon"></div> 
            <div class="text">{{lan.thank}}</div>
            <div v-if="showCenter" class="desc1">{{lan.welfareGroup}}</div>
            <div v-if="showCenter" class="desc2">
                <div class="qq">{{lan.addService}}</div>
                <div class="qqnumber">{{lan.qq}}</div>
                <button class="copy" id="copy" data-clipboard-target="#foo">{{lan.copy}}</button>
            </div>
            <div v-if="showCenter" class="desc3">{{lan.money}}</div>
            <div v-if="languageValue == 'zh-Hans'" class="back-btn" @click="back">{{lan.done}}</div>
            <div v-else class="back-btn" @click="back">{{lan.close}}</div>
            <input class="hideInput" id="foo" :value="lan.qq" />
            <transition name="fade">
                <div v-if="showError" class="mask1">
                    <div class="toast">
                        <div class="toast-text">{{errorMsg}}</div>
                    </div>
                </div>
            </transition>
        </div>        
    </transition>
</template>

<script>

import ClipboardJS from 'clipboard'
import lan from '../../common/lan'

/**
 * 获取url上的参数
 * @param name
 */
const getQueryString = (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window
        .location
        .search
        .substr(1)
        .match(reg);
    if (r != null)
        return unescape(r[2]);
    return null;
}


export default {
    name: 'success',
    data () {
        return {
            show: false,
            showCenter: false,
            showError: false,
            errorMsg: "复制成功",
            lan: lan[getQueryString("lan")]?lan[getQueryString("lan")]:lan["en"],
            languageValue:getQueryString("lan"),
            appName: getQueryString("appName")
        }
    },

    clip: null,

    mounted() {
        if (this.$data.appName == "inFace") {
            this.$data.lan = lan[this.$data.appName + "-" + getQueryString("lan")]?lan[this.$data.appName + "-" + getQueryString("lan")]:lan[this.$data.appName + "-en"]
        }
        let link = window.location.href
        if (link.indexOf('zh-Hans') >= 0) {
            this.$data.showCenter = true
        }

        setTimeout(() => {
            this.$data.show = true
        }, 300)

        this.clip = new ClipboardJS('.copy')

        this.clip.on('success', () => {
            this.$data.showError = true
            setTimeout(() => {
                this.$data.showError = false
            }, 2000)
        })
    },

    methods: {
        back: function() {
            //this.$router.back()
            //window.closePage && window.closePage()
            window.webkit.messageHandlers.closePage.postMessage("")
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
}

h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

button {
    padding: 0 auto;
    margin: 0 auto;
    border: none;
    background: none;
}

.mask1 {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.toast {
    padding: 0 20px 0 20px;
    min-width: 126px;
    height:66px;
    background:rgba(29,28,28,0.7);
    border-radius:12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    flex-direction: row;
}

.toast-text {
    color: white;
    font-size: 14px;
    text-align: center;
    margin: 0 0 0 5px;
}

input, textarea {
    border: none;
    margin: none;
    padding: 0 auto;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    outline: none;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: white;
}

.hideInput {
    width: 20px;
    height: 10px;
    position: absolute;
    left: -9999px;
    top: -9999;
}

.icon {
    width: 88px;
    height: 88px;
    background:url(../../assets/icon_success.png);
    background-repeat: no-repeat;
    background-size: cover;    
}

.text {
    width: 100%;
    height: 28px;
    line-height: 28px;
    color: black;
    margin: 12px 0 0 0;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
}

.desc1 {
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: white;
    font-size: 14px;
    text-align: center;
    margin: 70px 0 0 0;
}

.desc2 {
    width: 100%;
    height: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 6px 0 0 0;
    color: white;
    font-size: 14px;
    text-align: center;
    font-weight: 500;
}

.qq {
    width: auto;
    height: 16px;  
}

.qqnumber {
    width: auto;
    height: 16px; 
}

.copy {
    color: #7AD3FF;
    margin: 2px 0 0 5px;
}

.desc3 {
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: white;
    margin: 6px 0 0 0;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
}

.back-btn {
    width:238px;
    height:50px;
    background-image: linear-gradient(to right, #474747 , #282828);
    border-radius:2px;
    line-height: 50px;
    color:#e5c9b6;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, .2);
    font-weight: bold;
    margin: 20px 0 0 0;
}

</style>


// WEBPACK FOOTER //
// src/page/success/Success.vue